/**
 * The focused element, piercing shadow roots. `document.activeElement` only
 * reports the outermost host, not the control focused inside its shadow DOM.
 *
 * @returns {Element | null}
 */
export function deepActiveElement() {
  let active = document.activeElement;
  while (active?.shadowRoot?.activeElement) {
    active = active.shadowRoot.activeElement;
  }
  return active;
}

/**
 * Whether the focused element is `element` or sits inside it in the composed tree. `contains()`
 * stops at a shadow boundary and cannot see slotted light-DOM content, so the walk hops through
 * `assignedSlot` and shadow hosts.
 *
 * @param {Element | null | undefined} element
 * @returns {boolean}
 */
export function focusWithin(element) {
  if (!element) {
    return false;
  }

  let node = deepActiveElement();
  while (node) {
    if (node === element) {
      return true;
    }
    node = node.assignedSlot ?? node.parentNode ?? node.host ?? null;
  }

  return false;
}
